// extracted by mini-css-extract-plugin
export default {"container":"selectedRangeLabel_container__kog9+","value":"selectedRangeLabel_value__St1ro"};